import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Input } from './Input';
import { useOwasEvaluationContext } from '../context';
import * as S from './styles';

export enum TASKS_FILTER {
	ALL = 'all',
	NOT_ANALYZED = 'not_analyzed'
}

export function Filters() {
	const { filters, onFilterAnalyzed } = useOwasEvaluationContext();

	function handleOnClick(type: string): void {
		onFilterAnalyzed(type);
	}

	return (
		<Row justify="center" align="middle" gutter={[14, 0]}>
			<Col xxl={16} sm={12}>
				<Input />
			</Col>
			<Col xxl={8} sm={12}>
				<Row justify="center" align="middle" gutter={[14, 0]}>
					<Col span={12}>
						<S.ButtonWrapper
							$selected={filters.type === TASKS_FILTER.ALL}
							onClick={() => handleOnClick(TASKS_FILTER.ALL)}
						>
							{I18n.get('All tasks')}
						</S.ButtonWrapper>
					</Col>
					<Col span={12}>
						<S.ButtonWrapper
							$selected={filters.type === TASKS_FILTER.NOT_ANALYZED}
							onClick={() => handleOnClick(TASKS_FILTER.NOT_ANALYZED)}
						>
							{I18n.get('Tasks not analyzed')}
						</S.ButtonWrapper>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
